.productCardImage {
  aspect-ratio: 1;
}

.productCardImage img {
  cursor: pointer;
  border-radius: var(--card-border-radius);
}

.productCardImage div {
  cursor: pointer;
}

.productLink {
  text-decoration: none;
}

/* Mid-grid placement card variant */
.productCardPlacement {
  background-color: var(--colors-grays-white);
  border-radius: var(--card-border-radius);
}

.productCardPlacement .productCardImage {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.productCardPlacement .productCardImage img {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.productCardPlacement .priceAndAddToCartContainer {
  padding: 0 8px 8px;
}
